if (!customElements.get("c-search-wrapper")) {
  customElements.define(
    "c-search-wrapper",
    class ComponentSearchWrapper extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.input = this.querySelector("#search-input");
        this.resultsContainer = this.querySelector("#search-results");

        this.input.addEventListener("input", this.inputHandler);

        document.addEventListener("click", this.closeResults);
      }

      disconnectedCallback() {
        input.removeEventListener("input", this.inputHandler);

        document.removeEventListener("click", this.closeResults);
      }

      closeResults = (event) => {
        if (!this.resultsContainer.contains(event.target) && event.target !== this.input) {
          this.resultsContainer.style.display = "none";
        }
      }

      inputHandler = () => {
        const query = this.input.value.trim();
        if (query.length < 2) {
          this.resultsContainer.style.display = "none";
          return;
        }
      
        const localeMatch = window.location.pathname.match(/^\/(en-us|fr)\//);
        const localePrefix = localeMatch ? `/${localeMatch[1]}` : "";
        fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`
        )
          .then((res) => res.json())
          .then((data) => {
            this.resultsContainer.innerHTML = "";
      
            const products = data.resources.results.products;
      
            if (products.length === 0) {
              this.resultsContainer.style.display = "none";
              return;
            }
      
            products.forEach((product) => {
              const link = document.createElement("a");
              link.href = localePrefix + product.url;
              link.classList.add("search-result-item");
      
              const img = document.createElement("img");
              img.src = product.image; 
              img.alt = product.title;
              img.classList.add("search-result-image");
      
              const title = document.createElement("span");
              title.textContent = product.title;
      
              link.appendChild(img);
              link.appendChild(title);
              this.resultsContainer.appendChild(link);
            });
      
            this.resultsContainer.style.display = "block";
          })
          .catch((err) => console.error("Search error:", err));
      }
    }
  );
}
